/* eslint-disable no-prototype-builtins */
import React, { useState, useEffect } from 'react'
import { useNavigate, useParams, Link } from 'react-router-dom'
import axios from 'axios'
import ReactHtmlParser from 'react-html-parser'

import Box from '@mui/material/Box'
import Divider from '@mui/material/Divider'
import Typography from '@mui/material/Typography'

import { descriptionTextField } from '../../../helpers/textfields'
import { hingeProfileImageDimension } from '../../../helpers/variableDefaults'

export const giveFeedbackGeneralAnalysisJSX = (profileReview, setProfileReview, width, errors, setErrors, loading, setLoading) => {
  
  const handleChangeGeneralAnalysis = (e) => {
    // console.log('handleChangeGeneralAnalysis runs')

    const { name, value } = e.target
    // console.log('name ->', name)
    // console.log('value ->', value)

    const updatedGeneralFeedback = { ...profileReview.generalFeedback, [name]: value }
    setProfileReview({ ...profileReview, generalFeedback: updatedGeneralFeedback })

  }

  const generalAnalysisBackgroundColor = () => {
    return (
      (
        profileReview !== null 
        && 'generalFeedback' in profileReview
      )
      &&
      (
        'vibe' in profileReview.generalFeedback
        && profileReview.generalFeedback.vibe.length > 0
      )
      &&
      (
        'good' in profileReview.generalFeedback
        && profileReview.generalFeedback.good.length > 0
      )
      &&
      (
        'notGood' in profileReview.generalFeedback
        && profileReview.generalFeedback.notGood.length > 0
      )
      &&
      (
        'verdict' in profileReview.generalFeedback
        && profileReview.generalFeedback.verdict.length > 0
      )
        ?
        'lightblue'
        :
        'mistyrose'
    )
  }

  const questionAnswerElementJSX = (question, elementName, elementValue, placeholderText) => {
    return (
      <Box
        sx={{
          width: '100%',
          display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start',
        }}
      >
        
        {/* Divider */}
        {/* {elementName !== 'vibe' &&
          <Divider sx={{ width: '100%', my: 0 }} orientation="horizontal" />
        } */}

        {/* Question */}
        <Box
          sx={{
            pt: 2, px: 2,
            fontWeight: 'bold',
            display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start',
          }}
        >
          {question}
        </Box>

        {/* Feedback */}
        <Box
          sx={{
            px: 2,
            mt: 1,
            width: '100%',
          }}
        >
          {descriptionTextField(
            elementName,
            elementValue,
            -1,
            ``,
            5,
            300,
            placeholderText,
            true,
            handleChangeGeneralAnalysis,
            setErrors,
            setProfileReview,
            profileReview,
            0
          )}
        </Box>
      </Box>
    )
  }

  return (
    <Box
      sx={{
        mt: 0, py: 2,
        width: hingeProfileImageDimension(width),
        backgroundColor: generalAnalysisBackgroundColor(),
        // backgroundColor: 'mistyrose',
        // boxShadow: 3, 
        border: 1,
        borderColor: 'gainsboro',
        borderRadius: '10px',
        display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start',
      }}
    >

      {/* Title */}
      <Box
        sx={{
          width: '100%',
          fontSize: '18px',
          fontWeight: 'bold',
          display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'flex-start',
        }}
      >
        Analysis
      </Box>

      {/* Vibe */}
      {questionAnswerElementJSX(
        `What is your impression of the person based on the profile?`, 
        'vibe',
        profileReview !== null && 'generalFeedback' in profileReview && 'vibe' in profileReview.generalFeedback ? profileReview.generalFeedback.vibe : '',
        `Describe the vibe you're getting (Required)`
      )}
      

      {/* Pros */}
      {questionAnswerElementJSX(
        `What do you like about the profile?`, 
        'good',
        profileReview !== null && 'generalFeedback' in profileReview && 'good' in profileReview.generalFeedback ? profileReview.generalFeedback.good : '',
        `Describe the highlights (Required)`
      )}
      
      {/* Cons */}
      {questionAnswerElementJSX(
        `What are the main areas for improvement for this profile?`, 
        'notGood',
        profileReview !== null && 'generalFeedback' in profileReview && 'notGood' in profileReview.generalFeedback ? profileReview.generalFeedback.notGood : '',
        `Describe the lowlights (Required)`
      )}

      {/* Verdict */}
      {questionAnswerElementJSX(
        `Overall, does ${profileReview.bio.vitalInfo.firstName}'s profile showcase ${profileReview.bio.vitalInfo.gender === 'Male' ? 'his' : profileReview.bio.vitalInfo.gender === 'Female' ? 'her' : 'their' } most attractive self?`,
        'verdict',
        profileReview !== null && 'generalFeedback' in profileReview && 'verdict' in profileReview.generalFeedback ? profileReview.generalFeedback.verdict : '',
        `Decision time — has this profile won you over? (Required)`
      )}

    </Box>
  )
}